<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="120"></v-progress-circular>
    </v-overlay>
    <v-alert v-if="assignment_data && assignment_data.status == 'Incomplete' && !$store.state.recordingEng" elevation="2" class="mb-3 mt-3" type="error">
      The following items are still awaiting your review and approval:<br>
      <span v-if="!assignment_data.b_location_reviewed">• Location Information<br></span>
      <span v-if="!assignment_data.contact_info_completed">• On-Site Contact Information<br></span>
      <span v-if="!assignment_data.wifi_info_completed">• WiFi Information<br></span>
      <span v-if="!assignment_data.b_equipment_reviewed">• Misc. Equipment and Support Staff<br></span>
      <span v-if="!assignment_data.b_equipment_approved">• Equipment List<br></span>
      <span v-if="assignment_data.payment_breakdown_sum == 0">• Need to enter a Payment Information<br></span>
    </v-alert>
    <v-row v-if="assignment_data">
      <v-col cols="12" sm="6">
        <LocationInfo @loaddata="loadData" :assignment_data="assignment_data"/>
        <br>
        <RecEngPayment v-if="$store.state.recordingEng" :assignment_data="assignment_data"/>
        <SetupDateTime v-if="!$store.state.recordingEng" :assignment_data="assignment_data"/>
        <br>
        <RequiredDateTime v-if="!$store.state.recordingEng"/>
        <v-btn v-if="$store.state.recordingEng" color="primary" href="https://docs.google.com/document/d/1LDT3UDS-YdBhS69PU94YzF5LMl55rBCpVb__0yiGYOo" target="_blank">Recording Engineer Procedure</v-btn>
        <br>
        <EquipmentReview v-if="!$store.state.recordingEng" @loaddata="loadData" :assignment_data="assignment_data"/>
      </v-col>
      <v-col cols="12" sm="6">
        <ContactInfo :loading="info_loading" :assignment_data="assignment_data" @updateinfo="updateInfo"/>
        <br>
        <WiFi v-if="!$store.state.recordingEng" :loading="wifi_loading" :assignment_data="assignment_data" @updateinfo="updateWifi"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/functions'
import ContactInfo from './Overview/ContactInfo'
import WiFi from './Overview/WiFi'
import LocationInfo from './Overview/LocationInfo'
import SetupDateTime from './Overview/SetupDateTime'
import RequiredDateTime from './Overview/RequiredDateTime'
import EquipmentReview from './Overview/EquipmentReview'
import RecEngPayment from './Overview/RecEngPayment'

export default {
  components: {
    ContactInfo,
    WiFi,
    LocationInfo,
    SetupDateTime,
    RequiredDateTime,
    EquipmentReview,
    RecEngPayment
  },
  data() {
    return {
      assignment_data: null,
      loading: true,
      info_loading: false,
      wifi_loading: false
    }
  },
  methods: {
    async sendData(data) {
      const vm = this
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      await putOpusApi({
        table: `vendor_assignments`,
        params: data
      }).then(function() {
        vm.loadData()
      })
    },
    async updateInfo() {
      const id = this.$store.state.assignment
      this.info_loading = true
      await this.sendData({ 
        id: id,
        Contact_Name: this.assignment_data.contact_name,
        Contact_Work_Phone: this.assignment_data.contact_work_phone,
        Contact_Cell_Phone: this.assignment_data.contact_cell_phone,
        Contact_Email_Address: this.assignment_data.contact_email_address
      })
      this.info_loading = false
    },
    async updateWifi() {
      const id = this.$store.state.assignment
      this.wifi_loading = true
      await this.sendData({ 
        id: id,
        WifiName: this.assignment_data.wifi_name,
        WifiPassword: this.assignment_data.wifi_password
      })
      this.wifi_loading = false
    },
    async loadData() {
      const vm = this
      const id = vm.$store.state.assignment
      const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

      vm.loading = true
      await getOpusApi({
        table: `vendor_assignments/${id}`,
        params: {
          include: 'perf_facility_map,performance_site'
        }
      }).then(function(response) {
        if(response.data == 'Not Authorized' || response.data == 'Authorization Error') {
          const assignmentHeader = 'Unable to find your email assigned to this assignment.'
          vm.$store.commit('setAssignmentHeader', assignmentHeader)
          vm.loading = false
          return
        }
        vm.assignment_data = response.data.result
        // console.log(vm.assignment_data)
        const assignmentHeader = `${vm.assignment_data.performance_site.event_name} - ${moment(vm.assignment_data.performance_site.f_date_start).format('MM/DD/YY')} - ${moment(vm.assignment_data.performance_site.f_date_end).format('MM/DD/YY')} - ${vm.assignment_data.performance_site.name}`
        vm.$store.commit('setAssignmentHeader', assignmentHeader)
        vm.$store.commit('setRecordingEng', vm.assignment_data.b_recording_engineer_mark == 1 ? true : false)
        vm.loading = false
      })
    }
  },
  filters: {
    formatDate: function(date) {
      return moment.utc(date).format('dddd, MMMM Do')
    },
    formatTime: function(time) {
      return moment.utc(time).format('h A')
    }
  },
  async mounted() {
    // sets nav sidebar selection
    this.$store.commit('setLoading', true)
    this.$store.commit('setNavIndex', this.$vuetify.breakpoint.mdAndDown ? 1 : 0)
    await this.loadData()
    this.$store.commit('setLoading', false)
  }
}
</script>